import './abandoned_call_factory';
import './call_forward_factory';
import './chat_session_factory';
import './content_placeholder_factory';
import './context_event_factory';
import './conversation_message_factory';
import './conversation_note_factory';
import './conversation_status_change_factory';
import './conversation_topic_change_factory';
import './customer_assignee_change_factory';
import './email_message_factory';
import './email_preview_factory';
import './email_send_failure_factory';
import './customer_activity_factory';
import './fb_message_incoming';
import './fb_message_outgoing';
import './help_app_context_factory';
import './hotel_reservation_factory';
import './item_link_factory';
import './marketing_email_factory';
import './message_content_type_file_factory';
import './message_content_type_image_factory';
import './message_content_type_location_factory';
import './message_content_type_text_factory';
import './mobile_context_factory';
import './narvar_factory';
import './no_reply_needed_factory';
import './payment_status_event_content_factory';
import './phone_call_factory';
import './phone_callback_factory';
import './proactive_chat_content_factory';
import './routing_item_factory';
import './rule_disabled_loop_factory';
import './sms_message_factory';
import './task_factory';
import './task_due_content_factory';
import './task_edited_content_factory';
import './task_completion_content_factory';
import './task_reopened_content_factory';
import './task_routing_factory';
import './twitter_factory';
import './voicemail_factory';
import './voice_campaign_outreach_factory';
import './voice_campaign_outreach_result_factory';
import './voice_recording_deleted_factory';
import './web_context_factory';
import './web_form_factory';



// WEBPACK FOOTER //
// ./factories/conversation_items/index.js